import { lazy } from 'react';
const ConversionDetails = lazy(() => import('./ConversionDetails'));

const ConversionDetailsRoutes = [
  {
    path: '/conversiondetails',
    component: ConversionDetails
  }
];

export default ConversionDetailsRoutes;
